import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../helpers/Api";
import Loading from "../../components/Loading";
import QueueWaiting from "./QueueWaiting";

export default function QueueGuard({ children }) {
    const { id: eventId } = useParams();
    const [queueState, setQueueState] = useState(null);
    const [queueData, setQueueData] = useState(null);

    useEffect(() => {
        const storageKey = `queue_token_${eventId}`;
        const stored = localStorage.getItem(storageKey);
        const cached = stored ? JSON.parse(stored) : null;

        if (cached?.status === "active" && cached?.expires_at && new Date(cached.expires_at) > new Date()) {
            setQueueState("active");
            return;
        }

        api.post("/Queue/Join", { event_id: Number(eventId) })
            .then((res) => {
                const data = res?.data;
                localStorage.setItem(storageKey, JSON.stringify(data));
                setQueueData(data);
                setQueueState(data?.status === "active" ? "active" : "waiting");
            })
            .catch(() => {
                setQueueState("active");
            });
    }, [eventId]);

    if (queueState === null) return <Loading text="Verificando disponibilidad..." />;

    if (queueState === "waiting") {
        return (
            <QueueWaiting
                queueData={queueData}
                eventId={eventId}
                onActive={(expiresAt) => {
                    setQueueState("active");
                }}
            />
        );
    }

    return children;
}
